import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state = {
  searchInputValue: "",
  searchOption: "",
  customerType: "Individual"
};
var searchParamsVar = makeVar(init_state);
var initSearchParamsState = function initSearchParamsState() {
  searchParamsVar(init_state);
};
var updateSearchParams = function updateSearchParams(searchParams) {
  return searchParamsVar(_objectSpread2(_objectSpread2({}, searchParamsVar()), searchParams));
};

export { initSearchParamsState as i, searchParamsVar as s, updateSearchParams as u };
